import React from 'react';
import styles from './PrivacyPolicy.module.scss';
import Section from "./Section";
import {Subsection} from "./AboutUs";
import {stPRIVACY} from "./NavBar";
import { privacyPolicyContent } from '../content/privacyPolicyContent';

const PrivacyPolicy: React.FC = () => {
    return (
        <Section id={stPRIVACY}>
            <h1>{privacyPolicyContent.title}</h1>
            <p>Effective Date: {privacyPolicyContent.effectiveDate}</p>
            {privacyPolicyContent.introduction.map((paragraph, index) => (
                <p key={index} dangerouslySetInnerHTML={{__html: paragraph}} />
            ))}

            {privacyPolicyContent.sections.map((section, sectionIndex) => (
                <Subsection key={sectionIndex} className={styles.ss}>
                    <h2>{section.title}</h2>
                    {section.content.map((item, itemIndex) => {
                        if (typeof item === 'string') {
                            return <p key={itemIndex} dangerouslySetInnerHTML={{__html: item}} />;
                        } else if (Array.isArray(item)) {
                            return (
                                <ul key={itemIndex}>
                                    {item.map((listItem, listItemIndex) => (
                                        <li key={listItemIndex} dangerouslySetInnerHTML={{__html: listItem}} />
                                    ))}
                                </ul>
                            );
                        }
                        return null;
                    })}
                </Subsection>
            ))}
        </Section>
    );
};

export default PrivacyPolicy;
